export default __webpack_public_path__ + "static/media/whatcard1.479118ae.svg";